import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ISharedFileRequestResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";
import { ContextItem } from "../../../../types";
import { WSQueryCache } from "@ws-react-query";
import { QUERY_SHARED_FILE } from "../../../../../../query/sharedFile/keys";

export const getSharedFileFromCache = (
  requirement: IRequirementResponse,
  contextItem: ContextItem
): ISharedFileRequestResponse | undefined => {
  return WSQueryCache.getQueryData<ISharedFileRequestResponse>([
    QUERY_SHARED_FILE,
    requirement.dataSourceId
  ]);
};
